export const PAYMENT_FREQUENCY = {
  monthly: { value: 'monthly', label: 'mensual' }
};

export const SALARY_TYPES = {
  gross: { value: 'gross', label: 'gross' },
  net: { value: 'net', label: 'net' }
};

export const EMPLOYEE_STATUS = {
  active: { value: 'active', label: 'employee status.active' },
  on_leave: { value: 'on_leave', label: 'employee status.on_leave' },
  inactive: { value: 'inactive', label: 'employee status.inactive' },
  incomplete: {
    value: 'incomplete',
    label: 'employee status.incomplete',
    disabled: true
  },
  deleted: {
    value: 'deleted',
    label: 'employee status.deleted',
    disabled: true
  }
};

export const DOCUMENT_TYPE = {
  DNI: {
    label: 'employee documentType.dni',
    value: 'DNI'
  },
  NIE: {
    label: 'employee documentType.nie',
    value: 'NIE'
  },
  CODICE_FISCALE: {
    label: 'employee documentType.codicefiscale',
    value: 'CODICE_FISCALE'
  },
  PASSPORT: {
    label: 'employee documentType.passport',
    value: 'PASSPORT'
  },
  C_CIUDADANIA: {
    label: 'employee documentType.ciudadania',
    value: 'C_CIUDADANIA'
  },
  C_EXTRANJERIA: {
    label: 'employee documentType.extranjera',
    value: 'C_EXTRANJERIA'
  },
  PEP: {
    label: 'employee documentType.pep',
    value: 'PEP'
  },
  NIT: {
    label: 'employee documentType.nit',
    value: 'NIT'
  }
};

export const toSelect = (data, labelPrefix = '') =>
  data?.map(option => ({
    value: option,
    label: labelPrefix ? `${labelPrefix} ${option}` : option
  }));

export const PARENT_SUBSIDIARY_VALUE = 'null';
